import { Country } from '@superbet-group/web.types';

import { Target } from '../types/Target';
import { getSportOfferConfig } from '../../config/sportOfferConfig';

export function getCurrentTarget(): Target {
    switch (getSportOfferConfig().country) {
        case Country.Ro:
            return Target.SbRo;
        case Country.Pl:
            return Target.SbPl;
        case Country.Rs:
            return Target.SbRs;
        case Country.Be:
            return Target.NgBe;
        case Country.Com:
            return Target.SbCom;
        case Country.Br:
            return Target.SbBr;
        case Country.BrSocial:
            return Target.SbBr;
        default:
            return Target.SbOther;
    }
}
